// extracted by mini-css-extract-plugin
module.exports = {"container":"styles__container___35tez","panel":"styles__panel___3UMvW"};